



































































































import Openable from '@/global/viewmodels/openable'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import suiviCAMixin from './suiviCAMixin'
import mixins from 'vue-typed-mixins'

export default mixins(suiviCAMixin, mobileTypeMixin).extend({
    components: {
        BAlert: () => import('@/layout/components/BiobankAlert.vue'),
    },
    data() {
        return {
            alert: new Openable(),
        }
    },
    mounted() {
        this.alert.open()
    },
    methods: {},
})
